<div class="gallery">
  <div class="general">
    <div class="general_preview">
      <div class="image" *ngIf="!loader" (click)="openImage()">
        <!-- <div class="openImageBtn" (click)="openImage()"></div> -->
        <!-- <div *ngIf="currentLivingComplexePhoto" class="deleteImageBtn" (click)="openAlert(livingComplexId);$event.stopPropagation()">&#10005;</div>

        <div *ngIf="alertPhoto" class="alert">
          <div class="alert-body">
            <span> Вы точно хотите удалить? </span>
          </div>
          <div class="btns">
            <div class="btn btn-danger" (click)="deleteImageLivingComplexById(idForDelete);$event.stopPropagation()">Удалить</div>
            <div class="btn btn-apply" (click)="cancelAlert();$event.stopPropagation()">Отмена</div>
          </div>
        </div> -->

        <div class="btn btn-apply auto" *ngIf="!currentLivingComplexePhoto">
          Загрузить проектное фото для объекта
          <input  type="file"
          accept="image/png,image/jpg,image/jpeg,image/jfif,image/gif,image/tiff,image/psd,image/bmp,image/raw,image/svg,image/pct,image/tif"
          (change)="handleFileInput($event.target.files);" (click)="$event.stopPropagation()">
        </div>

        <ng-container *ngIf="!livingComplexLoader && currentLivingComplexePhoto" >
          <img  [src]="uri" alt=""  #myImg>
        </ng-container>
        <div class="loading" *ngIf="livingComplexLoader"></div>
      </div>
      <div class="loading" *ngIf="loader"></div>
    </div>
    <div class="general_album">
      <div class="album">
        <div class="album_images">
          <ng-container *ngIf="!lastFourImageForLivingComplexLoader">
            <div class="image" *ngFor="let img of lastFourImageForLivingComplex" (click)="openOnePhoto(img)">
              <img [src]="img.src" alt="" >
              <div *ngIf="img.type === 2" class="play-icon"> <img src="./assets/svg-icons/play.svg" alt=""> </div>
            </div>
          </ng-container>
          <div class="loading" *ngIf="lastFourImageForLivingComplexLoader"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="albums">
    <div class="album" *ngFor="let img of lastFour" (click)="openAlbum(img.id)">
      <ng-container *ngIf="!lastFourLoader">
        <div class="btn btn-apply auto">Загрузить фото</div>
        <div class="image" *ngFor="let it of img?.album">
            <img  [src]="it.src" alt="" >
              <div *ngIf="it.fileTypeId === 2" class="play-icon"> <img src="./assets/svg-icons/play.svg" alt=""> </div>
          </div>
        </ng-container>
        <div class="loading" *ngIf="lastFourLoader"></div>
        <div class="album_title" [ngStyle]="{'color':'black'}">Пятно {{img?.title}}</div>
    </div>
  </div>
</div>

<ng-container *ngIf="albumModal">
  <app-modal-window [title]="'Пятно ' + selectAlbumTitle" [visible]="albumModal" (close)="closeAlbum($event)" [height]="600" [type]="'album'">
    <app-object-album [livingComplexID]="livingComplexId" [buildingId]="selectAlbum"></app-object-album>
  </app-modal-window>
</ng-container>

<ng-container *ngIf="openImg">
  <app-modal-window [title]="'Главное фото объекта'" [visible]="openImg" (close)="openImg = $event" [scrollbar]="false" [type]="'preview'">
    <div class="img-block">
      <img [src]="uri" alt="" *ngIf="!livingComplexLoader" >
      <div class="loading" *ngIf="livingComplexLoader"></div>
    </div>
  </app-modal-window>
</ng-container>

<ng-container *ngIf="openOneImg">
  <app-modal-window [title]="''" [visible]="openOneImg" (close)="openOneImg = $event" [scrollbar]="false" [type]="'preview'">
    <ng-container *ngIf="allBuildingImage.length > 1">
      <div class="btn-slide to-left" (click)="clickedSlider('left', selectedOneImg)">❮</div>
      <div class="btn-slide to-right" (click)="clickedSlider('right', selectedOneImg)">❯</div>
    </ng-container>
    <div class="img-block">
      <img *ngIf="selectedOneImg.type === 1" [src]="selectedOneImg.srcFalse" alt="">
      <video *ngIf="selectedOneImg?.type === 2" width="100%" controls="controls" autoplay>
        <source [src]="selectedOneImg?.srcFalse">
      </video>
    </div>
  </app-modal-window>
</ng-container>
